import React, { useState } from 'react';

import { Icon } from '@mui/material';

import { CHEVRON_DOWN_V3, CHEVRON_UP_V3 } from '../../../../constants/images';
import { IDropdownButton } from '../../../../interfaces/buttons';
import BdsRadioButton from '../../BdsRadioButton/BdsRadioButton';
import GenericMenu from '../../GenericMenu/GenericMenu';
import BdsDivider from '../../Globals/BdsDivider/BdsDivider';

import './DropdownButton.scss';

const DropdownButton = ({
  selectionTitle,
  defaultOption,
  options,
  onChange,
  isExpandable = false,
  customClass = ''
}: IDropdownButton) => {
  const [open, setOpen] = useState(false);
  const openMenu = () => setOpen(!open);

  const handleChange = (value: string) => {
    const option = options.find((opt) => opt.value === value);
    if (option) {
      onChange(option);
      openMenu();
    }
  };

  const isDisplay = () => {
    return open ? 'show' : 'hide';
  };

  return (
    <div className={`dropdown-container ${customClass}`}>
      <button className="dropdown-button" onClick={openMenu}>
        {defaultOption}
        <Icon component={open ? CHEVRON_UP_V3.component : CHEVRON_DOWN_V3.component} className="bds-button-icon" />
      </button>
      <div className={`collapsable-section ${isDisplay()}`}>
        {isExpandable && (
          <div className="expandable-options">
            {options.map((opt) => (
              <div key={opt.value}>
                <button
                  className="option-button"
                  onClick={() => {
                    onChange(opt);
                    openMenu();
                  }}
                >
                  <div className="option-content">
                    <span className="option-label">{opt.name}</span>
                    <BdsRadioButton
                      variant="primary"
                      selected={defaultOption === opt.value}
                      value={opt.value}
                      name={selectionTitle}
                      onChange={() => {
                        onChange(opt);
                        openMenu();
                      }}
                    />
                  </div>
                </button>
                <BdsDivider size={'s'} color={'light'} />
              </div>
            ))}
          </div>
        )}
      </div>
      {!isExpandable && (
        <div className="dropdown-generic-menu">
          <GenericMenu
            title={selectionTitle}
            showGenericMenu={open}
            setShowGenericMenu={setOpen}
            type="custom"
            customData={{
              value: defaultOption,
              onChanged: (e) => {
                handleChange(e);
              },
              data: options.map((opt) => {
                return { name: opt.name, value: opt.value };
              })
            }}
          />
        </div>
      )}
    </div>
  );
};

export default DropdownButton;
